import { PublicRoutes } from "@/constants/routes";
import {
  FEATURED_INTEGRATIONS,
  integrationAnchor,
} from "../constants/integrations";
import { NavMenu } from "./navMenu";

const items = FEATURED_INTEGRATIONS.map(integration => ({
  key: integration.slug,
  title: integration.name,
  description: integration.menuDescription,
  to: integrationAnchor(integration.slug),
}));

export const IntegrationsMenu = () => (
  <NavMenu
    label="Integrações"
    items={items}
    footerText="Conecte o ERP que sua loja já usa."
    footerCta={{
      label: "Ver todas as integrações",
      to: PublicRoutes.INTEGRACOES,
    }}
  />
);
